/*=========================================================================================
  File Name: moduleProductState.js
  Description: Product Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  products: [], //Total Products List
  categories: [],
  brands: [],
};
